import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { useDispatch, useSelector } from "react-redux";
import LoginLeftBg from "../../assets/images/login-left-bg.png";
import LoginRightTopBg from "../../assets/images/login-right-top-bg.png";
import LoginRightBottomBg from "../../assets/images/Right-bottom.png";
import signLogo from "../../assets/images/signLogo.png";
import forgotPassword1 from "../../assets/images/forgot-password1.png";
import { BackArrowIcon, emailIcon } from "../../assets/icons";
import { otpSchema } from "../../Validations/AuthValidation";
import {
  reqToForgotPassword,
  reqToVerifyOtp,
} from "../../redux/slices.js/authentication/authenticationSlice";
import { routes } from "../../helpers/constants";
import Loader from "../../components/Loader";

const VerifyOtp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputRefs = useRef([]);
  const email = localStorage.getItem("forgotEmail");
  const loader = useSelector((state) => state.authentication.loader);

  const initialValues = {
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
    otp5: "",
    otp6: "",
  };

  const [timeLeft, setTimeLeft] = useState(300);
  const [resendVisible, setResendVisible] = useState(false);

  useEffect(() => {
    if (timeLeft <= 0) {
      setResendVisible(true);
      return;
    }
    const timerId = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleSubmit = (values) => {
    const otp =
      values.otp1 +
      values.otp2 +
      values.otp3 +
      values.otp4 +
      values.otp5 +
      values.otp6;
    const reqObj = { email, otp: Number(otp) };
    dispatch(
      reqToVerifyOtp({
        data: reqObj,
        onSuccess: () => navigate(routes.resetPassword),
        onFailure: () => {},
      })
    );
  };

  const resendOTP = () => {
    dispatch(
      reqToForgotPassword({
        data: { email },
        onSuccess: (res) => {
          notify(res?.data?.message, "success");
          localStorage.setItem("forgotEmail", email);
          setTimeLeft(300);
          setResendVisible(false);
        },
        onFailure: () => {},
      })
    );
  };

  const handleOtpChange = (e, index, setFieldValue) => {
    const digit = e.target.value.replace(/[^0-9]/g, "");
    setFieldValue(`otp${index + 1}`, digit);
    if (digit && index < 5) inputRefs.current[index + 1]?.focus();
  };

  const handlePaste = (e, setFieldValue) => {
    const pasted = e.clipboardData.getData("text").trim().slice(0, 6);
    pasted.split("").forEach((char, idx) => {
      if (idx < 6) {
        setFieldValue(`otp${idx + 1}`, char);
        inputRefs.current[idx].value = char;
      }
    });
    e.preventDefault();
  };

  return (
    <>
      {loader && <Loader />}
      <div className="signup-page bg-white">
        <div className="container">
          <div className="signup-container h-screen flex items-center flex-wrap relative">
            <div className="py-3 w-full lg:w-1/2 h-full hidden lg:flex">
              <div className="signup-left w-full h-full lg:flex items-start justify-between flex-col  bg-blue relative rounded-[30px]">
                <img
                  src={LoginLeftBg}
                  alt="LoginLeftBg"
                  className="absolute left-0 top-0 z-0"
                />
                <img
                  src={LoginRightTopBg}
                  alt="LoginRightTopBg"
                  className="absolute right-0 top-0 z-0"
                />
                <img
                  src={LoginRightBottomBg}
                  alt="LoginRightBottomBg"
                  className="absolute right-0 bottom-0 z-0"
                />
                <div className="signUpText flex flex-col gap-5 ps-[45px] pt-[35px]">
                  <img src={signLogo} className="max-w-[168px]" alt="" />
                </div>
                <img
                  src={forgotPassword1}
                  alt="signup"
                  className="mb-0 object-contain w-auto h-[70%] z-0"
                />
              </div>
            </div>

            <div
              className={`signup-right overflow-auto w-full lg:w-1/2 mx-auto md:px-[70px] h-full py-10 flex items-center justify-center flex-col px-4 relative`}
            >
              <div className="backArrow absolute md:left-[70px] top-10 left-4">
                <button
                  type="button"
                  aria-label="Go back"
                  onClick={() => navigate(-1)}
                  className="cursor-pointer"
                >
                  {BackArrowIcon}
                </button>
              </div>
              <div className="signup-right-title pb-[53px]">
                <div
                  className=" w-[84px] h-[84px]
    border-[16px] border-[#E3EAF9]
    rounded-full
    flex items-center justify-center
    mx-auto mb-[20px]"
                >
                  {emailIcon}
                </div>
                <h1 className="font-roboto mb-2 text-center text-black  inner-title">
                  Enter Verification code
                </h1>
                <p className="text-p mb-0 text-gray w-80 text-center">
                  We’ve sent an email with a code to {email}, please enter it
                  below the 6 digit code to reset your password.
                </p>
                {/* <span className="block text-black font-bold">{email}</span> */}
              </div>

              <div className={` w-full lg:max-w-lg space-y-4 pb-5`}>
                <Formik
                  initialValues={initialValues}
                  validationSchema={otpSchema}
                  onSubmit={handleSubmit}
                >
                  {({ setFieldValue, errors, values }) => (
                    <Form className="w-full signin-form space-y-4 h-full flex flex-col">
                      <div
                        className="flex items-center justify-center gap-4"
                        onPaste={(e) => handlePaste(e, setFieldValue)}
                      >
                        {[...Array(6)].map((_, index) => (
                          <Field
                            key={index}
                            name={`otp${index + 1}`}
                            innerRef={(el) => (inputRefs.current[index] = el)}
                            maxLength="1"
                            type="text"
                            inputMode="numeric"
                            className={`!w-[66px] !h-[89px] text-center border rounded !text-[24px] font-semibold focus:outline-none  ${
                              values?.[`otp${index + 1}`]
                                ? "!border-black focus:!border-black"
                                : "!border-gray-300 focus:!border-gray-300"
                            }`}
                            onChange={(e) =>
                              handleOtpChange(e, index, setFieldValue)
                            }
                            onKeyDown={(e) => {
                              if (
                                e.key === "Backspace" &&
                                !e.target.value &&
                                index > 0
                              ) {
                                inputRefs.current[index - 1]?.focus();
                              }
                            }}
                          />
                        ))}
                      </div>

                      {typeof errors === "string" ||
                      errors.otp1 ||
                      errors.otp2 ||
                      errors.otp3 ||
                      errors.otp4 ||
                      errors.otp5 ||
                      errors.otp6 ? (
                        <div className="text-red-500 text-sm text-center -mt-2">
                          Please complete the Verification code!
                        </div>
                      ) : null}

                      <div className="pt-5">
                        <button type="submit" className="btn-yellow mx-auto">
                          Confirm and proceed
                        </button>
                        <div className="flex justify-center gap-4 items-center flex-col mt-4">
                          {/* {resendVisible ? (
                            <button type="button" className="text-white login-btn" onClick={resendOTP}>Resend OTP</button>
                          ) : (
                            <span className="text-sm text-gray-600">Resend OTP in <span className="font-semibold">{formatTime(timeLeft)}</span></span>
                          )} */}
                          <span className="text-[16px] pt-0">
                            {" "}
                            Didn’t receive a code?{" "}
                            <span
                              className="font-semibold text-[##070707] hover:text-gray-800 hover:underline transition-colors cursor-pointer"
                              onClick={resendOTP}
                            >
                              {" "}
                              Send a new code{" "}
                            </span>{" "}
                          </span>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyOtp;
